"use client";

import { useState } from "react";
import Link from "next/link";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ThemeToggle } from "@/components/theme-toggle";
import type { SessionPayload } from "@/lib/session";

const navLink = "text-[15px] text-foreground no-underline hover:text-primary";

export default function Nav({
  session,
  signupHref = "/signup",
}: {
  session: SessionPayload | null;
  signupHref?: string;
}) {
  const [open, setOpen] = useState(false);

  return (
    <header className="border-b border-border">
      <div className="relative flex items-center gap-4 md:gap-6 px-4 md:px-8 py-4">
        <Link
          href={"/"}
          className="font-bold text-[19px] tracking-tight mr-auto no-underline text-foreground"
        >
          LastRedirect
        </Link>

        <ThemeToggle />

        <Button
          type="button"
          variant="ghost"
          size="icon"
          aria-expanded={open}
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen((v) => !v)}
          className="md:hidden"
        >
          {open ? <X /> : <Menu />}
        </Button>

        <div
          onClick={() => setOpen(false)}
          className={`${open ? "flex" : "hidden"} md:flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6 absolute md:static left-0 right-0 top-full md:top-auto z-10 bg-background md:bg-transparent border-b md:border-0 border-border px-4 md:px-0 py-4 md:py-0`}
        >
          <Link href="/#how" className={navLink}>
            How it works
          </Link>
          <Link href="/#features" className={navLink}>
            What you get
          </Link>
          <Link href="/#pricing" className={navLink}>
            Pricing
          </Link>
          <Link href="/#security" className={navLink}>
            Security
          </Link>
          <Link href="/#faq" className={navLink}>
            FAQ
          </Link>
          {session ? (
            <Button asChild className="md:ml-2">
              <Link href="/dashboard">Dashboard</Link>
            </Button>
          ) : (
            <Button asChild className="md:ml-2">
              <Link href={signupHref}>Sign up &amp; install →</Link>
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}
